import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Device } from 'src/app/models/centrex/device';
import { OrganizationsService } from '../organizations.service';
import { DeviceModel } from 'src/app/models/centrex/device-model';
import { ServiceBase } from '../service-base';

@Injectable({
    providedIn: 'root',
})
export class DeviceModelService extends ServiceBase {
    constructor(private http: HttpClient, private organizationsServices: OrganizationsService) {
        super();
    }

    getModels(): Observable<DeviceModel[]> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<DeviceModel[]>(`${this.baseUrl}/api/devicesmodels`, httpOptions);
    }

    getModel(modelName: string): Observable<DeviceModel> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Device>(`${this.baseUrl}/api/devicesmodels/${modelName}`, httpOptions);
    }
}
